import { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import EditIcon from '@mui/icons-material/Edit'
import { Box, IconButton, Tooltip } from '@mui/material'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import useIsMounted from '@hooks/useIsMounted'
import UserService from '@services/users/user.service'
import { ProjectInfoTableData } from '@models/projects.model'
import { OptionsContext } from '@contexts/Options'
import { Pagination, TableView } from '@components/customized/datatable'
import { sortByName } from '@utils/sortByName'
import { hasPermission } from '@utils/permission_helper'
import { PermissionCodeEnum } from '@models/permission'
import { AuthContext } from '@contexts/Auth'

export default function ProjectsTable() {
	const { t } = useTranslation()
	const { state, dispatch } = useContext(OptionsContext)
	const { state: authState } = useContext(AuthContext)
	const isMounted = useIsMounted()
	const refMounted = useRef(false)
	const [filterOptions, setFilterOptions] = useState<any>({})

	useEffect(() => {
		UserService.GetProjectsOptions({}).then((rep) => {
			setFilterOptions(rep)
		})
	}, [])

	useEffect(() => {
		if (state.project) {
			refMounted.current = true
		}
	}, [state])

	return (
		<>
			<TableView
				columns={[
					{
						key: 'display_name',
						desc: t('Projects'),
						renderCell: (params: ProjectInfoTableData) => {
							return (
								<Box>
									<Tooltip title={params?.display_name}>
										<Box sx={{ 'white-space': 'break-spaces' }}>{params?.display_name}</Box>
									</Tooltip>
								</Box>
							)
						},
					},
					{
						key: 'org_ids',
						desc: t('Organisation'),
						renderCell: (params: ProjectInfoTableData) => {
							const result = params?.org_ids
								?.map((org_id) => {
									state.organization?.find((x) => x.key === org_id)
								})
								?.join(',')
							return (
								<Box>
									<Tooltip title={result}>
										<Box sx={{ 'white-space': 'break-spaces' }}>{result}</Box>
									</Tooltip>
								</Box>
							)
						},
					},
					{
						key: 'id',
						desc: t('Function Buttons'),
						renderCell: (params: ProjectInfoTableData) => {
							return hasPermission(
								authState?.userInfo,
								[
									PermissionCodeEnum.RoleCreate,
									PermissionCodeEnum.RoleRead,
									PermissionCodeEnum.RoleUpdate,
									PermissionCodeEnum.RoleDelete,
									PermissionCodeEnum.RoleAssignUser,
								],
								params.project_id,
							) ? (
								<IconButton style={{ padding: '0px' }}>
									<EditIcon style={{ fontSize: '1rem' }}>{t('Edit')}</EditIcon>
								</IconButton>
							) : (
								<></>
							)
						},
						disableSort: true,
					},
				]}
				reloadCallback={async (req: any) => {
					if (refMounted.current) {
						const contextProjects = state.project
						const resp = await UserService.GetMyProfileProjectList(req)
						const myProjectList = resp?.data
						const totalCount = resp?.total_count
						const mergedProject = myProjectList?.map((myProject) => ({
							...myProject,
							...contextProjects?.find((project) => project.key === myProject.project_id),
						}))
						console.log('mergedProject', mergedProject)
						console.log('myProjectList', myProjectList)
						const result = mergedProject
							?.filter((contextProject) =>
								myProjectList?.some((myProject) => {
									return myProject.project_id === contextProject.key
								}),
							)
							?.map((project) => {
								return {
									id: project.key,
									project_id: project.key,
									display_name: project.value,
									org_ids: project.org_ids,
								}
							})
						console.log('result', result)
						return { data: result, total_count: totalCount }
					}
				}}
				toolbar={true}
				mountedRef={refMounted}
				onRowClick={function (navigate: NavigateFunction, record: ProjectInfoTableData) {
					if (
						hasPermission(
							authState?.userInfo,
							[
								PermissionCodeEnum.RoleCreate,
								PermissionCodeEnum.RoleRead,
								PermissionCodeEnum.RoleUpdate,
								PermissionCodeEnum.RoleDelete,
								PermissionCodeEnum.RoleAssignUser,
							],
							record.project_id,
						)
					)
						navigate(`/configurations/users_config/user_groups/${record.id}`)
				}}
				haveGlobalSearch={true}
				criterion={[
					// {
					// 	key: 'display_name',
					// 	name: t('Projects Name'),
					// 	type:  'StringFilter',
					// },
					{
						key: 'project_ids',
						name: t('Projects'),
						type: 'SelectionFilter',
						// options: state.project,
						options: sortByName(state.project)?.filter((elem: any) => {
							return filterOptions.project_ids?.includes(elem.key)
						}),
					},
					{
						key: 'active',
						name: t('Active'),
						type: 'ActiveFilter',
					},
					// {
					// 	key: 'is_deleted',
					// 	name: t('Is Deleted'),
					// 	type:  'SelectionFilter',
					// 	options: [{key: 'true', value: 'true'}, {key: 'false', value: 'false'}]
					// },
				]}
				defaultFilterCriteria={{ active: { operator: '=', value: [true] } }}
				defaultSorter={{ by: 'display_name', order_by: 'DESC' }}
			/>
		</>
	)
}
